import { createRouter, createWebHistory } from 'vue-router';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: () => import('./views/HomeView.vue') },
    { path: '/demo', component: () => import('./views/DemoView.vue') },
    { path: '/play/online', component: () => import('./views/LobbyView.vue') },
    /** Shareable private-room link: lands in the lobby with the code filled in (see LobbyView). */
    {
      path: '/join/:code',
      redirect: (to) => ({
        path: '/play/online',
        query: { ...to.query, room: String(to.params.code) },
      }),
    },
    { path: '/play/solo', component: () => import('./views/PlaySoloView.vue') },
    { path: '/match/:id', component: () => import('./views/MatchView.vue') },
    { path: '/match/:id/debug', component: () => import('./views/MatchDebugView.vue') },
    { path: '/decks', component: () => import('./views/DecksView.vue') },
    { path: '/decks/:id', component: () => import('./views/DeckEditorView.vue') },
    { path: '/settings', component: () => import('./views/SettingsView.vue') },
    { path: '/how-to-play', component: () => import('./views/HowToPlayView.vue') },
  ],
});
